module.exports = __webpack_public_path__ + "img/logo-simplyhealth.0177c48c.png";